import { Component, Vue } from "vue-property-decorator";
import JsBridge from "@/libs/jsBridge";
import Info from '../../components/info.vue';
@Component({
  components:{
    Info
  }
})
export default class Index extends Vue {
  isShow: boolean = false;

  trackingNo:string = '';
  express:string = '';
  status:string = '';

  showName:string = '';
  picUrl:string = '';
  identifyUrl:string = '';
  wayList:any = []
  created() {
    JsBridge.callShowTopNavigation({});
    this.getUserInfo()
    this.getInfo()
  }
  getUserInfo(){
    this.ajax({
      method:'get',
      url:'/api/donate/userInfo'
    }).then((res:any)=>{
        this.identifyUrl = res.data.certUrl;
        this.showName = res.data.showName;
        this.picUrl = res.data.picUrl;
    }).catch((err)=>{
        
    })
  }
  getInfo(){
    this.ajax({
      url:'/api/donate/my',
      method:'get'
    }).then((res:any)=>{
      this.wayList = res.data.expressInfo;
      this.trackingNo = res.data.trackingNo;
      this.express = res.data.express || '';
      this.status = res.data.status || '';

    })
  }
  onToggle(){
    this.isShow = !this.isShow;
  }
  onDown(){
    let data = {
      title: '我正在筹建一间乡村公益图书室，快来加入我吧！',
      detail: '我已经加入了“纸条公益图书室2024计划”：将旧书变新知，在知识的边疆，我们益路同行。',
      url:this.identifyUrl,
      thumbUrl: this.identifyUrl,
      shareType: [7],
      contentType: 2,
    };
    JsBridge.callShareObject(JSON.stringify(data));
  }
}
